(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aaoo-brand-navigation"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const link = event.target.closest('.aaoo-browse a');
    if (!link) return;
    const sort = new URL(window.location.href).searchParams.get('sort_by');
    if (!sort) return;
    const destination = new URL(link.href);
    destination.searchParams.set('sort_by', sort);
    link.href = destination.href;
  });
  } catch(e) { console.error(e); }
})();

})();
